const getDataInSession = (dataName) => {
    return window.sessionStorage.getItem(dataName);
}

const setDataInSession = (dataName, data) => {
    window.sessionStorage.setItem(dataName, data);
}

const removeDataInSession = (dataName) => {
    window.sessionStorage.removeItem(dataName);
}

const getDataInLocal = (dataName) => {
    return window.localStorage.getItem(dataName);
}

const setDataInLocal = (dataName, data) => {
    window.localStorage.setItem(dataName, data);
}

const removeDataInLocal = (dataName) => {
    window.localStorage.removeItem(dataName);
}

const getData = (dataName, isLocal) => {
    if (isLocal) {
        return getDataInLocal(dataName);
    } else {
        return getDataInSession(dataName);
    }
}

const setData = (dataName, data, isLocal) => {
    if (isLocal) {
        setDataInLocal(dataName, data);
    } else {
        setDataInSession(dataName, data);
    }
} 

const removeData = (dataName, isLocal) => {
    if (isLocal) {
        removeDataInLocal(dataName);
    } else {
        removeDataInSession(dataName);
    }
}

export const PortalClientStorage = {
    getData,
    setData,
    removeData
}
